import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Product } from '@app/forms/subscription/definition/interface/Pledge';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { UntypedFormArray } from '@angular/forms';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { ProductDao } from '@app/dao/product/product.dao';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'rcda-comparaison-products',
    templateUrl: './rcda-comparaison-products.component.html',
    styleUrls: ['./rcda-comparaison-products.component.scss'],
    standalone: false
})
export class RcdaComparaisonProductsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('linearVerticalStepper', { static: true })
  private steper: MatStepper;
  products: Product[] = [];
  rcdaComparedProductsChoices: Product[] = [];
  currentPageNumber: number = 0;
  itemsPerPage: number = 1;
  organizationId: number;
  productType: string;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
    protected attributionDao: AttributionDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.products = pledge?.products;

    this.attributionDao.getOrganization().subscribe(organization => {
      this.organizationId = organization.id;
      this.productType = pledge.productType;
      this.productDao
        .getGlobalByProductTypeAndOrganizationId(
          this.productType,
          this.organizationId,
        )
        .subscribe(products => {
          this.rcdaComparedProductsChoices = products;
          this.initForm(pledge?.products);
        });
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);
    this.extract();

    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber == this.products.length - 1
    )
      this.subscriptionFacade.submitPledge(this, 'products');
    if (
      this.scpis.controls[this.currentPageNumber]?.valid &&
      this.currentPageNumber < this.products.length - 1
    ) {
      this.subscriptionFacade.submitPledge(
        this,
        'products',
        false,
        this.nextStep.bind(this),
        true,
      );
    }
  }
  prev() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
    this.steper.previous();
  }
  nextPage() {
    this.currentPageNumber++;
  }

  nextStep() {
    this.currentPageNumber++;
    this.steper.next();
    this.steper.selected.completed = true;
  }
  prevStep() {
    if (this.currentPageNumber == 0) {
      this.subscriptionFacade.previousStep();
      this.steper.previous();
    }
    if (this.currentPageNumber > 0) this.currentPageNumber--;
  }
  stepClick(ev) {
    this.currentPageNumber = ev.selectedIndex;
  }

  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }
}
